/**
 * The engines a brand may be measured on, in the order the server hands them
 * out — a copy of `Engine::ALL` in `server/src/asale/client.rs`.
 *
 * A copy rather than a request, because the filter bar on every screen and
 * the wizard's picker both need the list before anything has loaded, and a
 * dropdown that fills in a second after the page is a dropdown somebody has
 * already clicked. The i18n test reads the Rust table and fails when the two
 * drift. The names are `engine.<key>` strings, because the Chinese assistants
 * are called differently in the two languages.
 */
interface EngineInfo {
	key: string;
}

export const ENGINES: readonly EngineInfo[] = [
	{ key: "chatgpt" },
	{ key: "perplexity" },
	{ key: "gemini" },
	{ key: "claude" },
	{ key: "grok" },
	{ key: "deepseek" },
	{ key: "qwen" },
	{ key: "kimi" },
	{ key: "doubao" },
	{ key: "glm" },
	{ key: "hunyuan" },
];
